import styled from 'styled-components';

export const StyledQrView = styled.div`
  height: 100%;
  padding-block: 20px;
  border-radius: 6px;
  background-color: #fbfbfb;
  border: 1px solid #f5f6f8;
`;
